"use client";

import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {
  BASE_WEB_REPORTS_API_URL,
  BASIC_AUTH,
  formatMonthDate,
  formatDateForDatabase,
} from "../constants";
import React from "react";
import { notifyError } from "../components/notify";
import TableLoader from "../components/Spinner/TableLoader";
import DateInput from "../components/DatePicker";
import ButtonSpinner from "../components/Spinner/ButtonSpinner";
import { useOutletContext } from "react-router-dom";

const Ledger = () => {
  const customerStr = localStorage.getItem("customerInfo");
  const customer = customerStr ? JSON.parse(customerStr) : null;

  const [filterapplied, setFilterApplied] = useState(false);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [table_loading, setTable_Loading] = useState(false);

  const [customerLedgerData, setCustomerLedgerData] = useState(null);

  const { setPageTitle } = useOutletContext();
  useEffect(() => {
    setPageTitle("Ledger");
  }, [setPageTitle]);

  const fetchCustomerLedgerReports = useCallback(async () => {
    setTable_Loading(true);

    let formatedStartDate = formatDateForDatabase(startDate);
    let formatedendDate = formatDateForDatabase(endDate);

    try {
      const response = await axios.get(
        `${BASE_WEB_REPORTS_API_URL}/get_customer_ledger_report?companycode=${customer?.companycode}&branchcode=${customer?.branchcode}&customercode=${customer?.customercode}&from_date=${formatedStartDate}&to_date=${formatedendDate}`,
        {
          headers: {
            Authorization: BASIC_AUTH,
          },
        },
      );

      if (response.status === 200) {
        setCustomerLedgerData(response.data);

        setFilterApplied(true);
      }
    } catch (err) {
      if (err && err.response) {
        const errorMessage =
          err.response.data?.message ||
          err.response.data?.error ||
          err.response.data?.errors ||
          "Unknown error from API";

        if (err.response.data?.errors) {
          notifyError(
            `Field validation errors: ${JSON.stringify(
              err.response.data.errors,
            )}`,
          );
        } else {
          notifyError(`${errorMessage}`);
        }
      } else {
        notifyError(`${err.message || err}`);
      }
      setCustomerLedgerData([]);
    } finally {
      setTable_Loading(false);
    }
  }, [
    customer?.companycode,
    customer?.branchcode,
    customer?.customercode,
    startDate,
    endDate,
  ]);

  const rows = Array.isArray(customerLedgerData?.ledger)
    ? customerLedgerData?.ledger
    : [];

  return (
    <>
      <div className="card bg-black mb-4 px-0">
        <div className="card-header  py-3 px-3">
          <div className="col-12  d-lg-flex d-block px-2 pt-3 g-2 align-items-center">
            {/* From Date */}
            <div className="col-12 col-lg-5 d-lg-flex d-block d-md-flex">
              <label className="col-12 col-lg-5 col-md-6 text-sm text-theme fw-bold mt-1">
                Select From Date <span className="red-error">*</span>
              </label>
              <div className="col-12 col-lg-6 col-md-6">
                <DateInput
                  selected={startDate}
                  onChange={setStartDate}
                  defaultMonth={startDate || new Date()}
                />
              </div>
            </div>

            {/* To Date */}
            <div className="col-12 col-lg-3  mt-2 mt-lg-0 d-lg-flex d-md-flex d-block">
              <label className="col-12 col-md-6 col-lg-4 text-sm text-theme fw-bold mt-1">
                To Date <span className="red-error">*</span>
              </label>
              <div className="col-12 col-md-6 col-lg-8">
                <DateInput
                  selected={endDate}
                  onChange={setEndDate}
                  defaultMonth={endDate || new Date()}
                />
              </div>
            </div>

            {/* Proceed Button */}
            <div className="col-11 col-md-6 col-lg-3 d-flex align-items-center justify-content-lg-center justify-content-start mt-2 mt-lg-0">
              <ButtonSpinner
                type="submit"
                className="col-md-7 col-lg-9 col-7  btn-theme btn-md text-black"
                loading={table_loading}
                onClick={fetchCustomerLedgerReports}
              >
                <b>{table_loading ? "Proceeding..." : "Proceed"}</b>
              </ButtonSpinner>
            </div>
          </div>
        </div>

        {table_loading ? (
          <TableLoader
            message={`Loading data...`}
            size="sm"
            messageClass="tablemessage-white py-3"
            spinnerClass="tablespinner-white"
          />
        ) : (
          <>
            <hr className="text-white"></hr>
            <div className="card-body px-2 pt-0 pb-2">
              {rows && filterapplied && (
                <>
                  <div className="col-12 bg-black d-flex">
                    <div className="col-12 d-flex text-white font-weight-bolder">
                      <div className="col-12 col-md-4">
                        <div>
                          Customer Name : {customerLedgerData?.customer_name}
                        </div>
                        <div>
                          Customer Outstanding:{" "}
                          {customerLedgerData?.customer_balance}
                        </div>
                      </div>

                      <div className="col-12 col-md-4 text-md-center text-start">
                        {formatMonthDate(customerLedgerData?.from_date)} To{" "}
                        {formatMonthDate(customerLedgerData?.to_date)}
                      </div>

                      <div className="col-12 col-md-4 text-md-end">
                        Mobile No : {customerLedgerData?.mobile_no}
                        {/* <div className="text-end">
              <button
                type="button"
                onClick={exportSupplierLedgerToExcel}
                className="btn btn-secondary mt-2 mb-0"
              >
                Export to Excel
                <i className="fas fa-file-excel ms-2"></i>
              </button>
            </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="table-container">
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm align-middle">
                        <thead className="table-dark">
                          <tr>
                            <th className="text-center">Sr.No</th>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Sale / Receipt No.</th>
                            <th className="text-end">Debit</th>
                            <th className="text-end">Discount</th>
                            <th className="text-end">Credit</th>
                            <th className="text-end">Close Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.length > 0 ? (
                            rows.map((row, index) => {
                              const isSpecialRow =
                                row.entry_type === "Opening Balance" ||
                                row.entry_type === "Closing Balance";

                              return (
                                <tr key={index}>
                                  <td className="text-center">{index + 1}</td>
                                  <td>{formatMonthDate(row.trscdate)}</td>
                                  <td>
                                    {isSpecialRow ? (
                                      <strong>{row.entry_type}</strong>
                                    ) : (
                                      row.entry_type
                                    )}
                                  </td>
                                  <td>{row.bill_no}</td>
                                  <td className="text-end">
                                    {parseFloat(row.debit_amount || 0).toFixed(
                                      2,
                                    )}
                                  </td>
                                  <td className="text-end">
                                    {parseFloat(
                                      row.discount_amount || 0,
                                    ).toFixed(2)}
                                  </td>
                                  <td className="text-end">
                                    {parseFloat(row.credit_amount || 0).toFixed(
                                      2,
                                    )}
                                  </td>
                                  <td className="text-end">
                                    {row.entry_type === "Closing Balance" ? (
                                      <strong>
                                        {parseFloat(
                                          row.close_balance || 0,
                                        ).toFixed(2)}
                                      </strong>
                                    ) : (
                                      parseFloat(
                                        row.close_balance || 0,
                                      ).toFixed(2)
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={8} className="text-center">
                                No records found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Ledger;
